import { useAuthStore } from '../../stores/authStore';
import { t } from '../../i18n/pt';
import { ResendVerificationButton } from './ResendVerificationButton';
import styles from './EmailVerifyBanner.module.scss';

/**
 * Persistent notice shown to logged-in customers whose email is not yet
 * verified. Renders nothing for guests, verified users, or staff.
 */
export function EmailVerifyBanner(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  if (!user || user.emailVerified) return null;

  return (
    <div className={styles.banner} role="status">
      <span className={styles.text}>{t.auth.verifyBannerText}</span>
      <span className={styles.actions}>
        <ResendVerificationButton
          variant="secondary"
          size="md"
          messageClassName={styles.message}
        />
      </span>
    </div>
  );
}
